import { ListItemText, MenuItem } from '@mui/material';
import React from 'react';

import { ActionMenuItemIcon } from './ActionMenuItemIcon';
import { type IconType } from '../../../mui-wrapper-components/Icon/Icon';

export type ActionMenuItemProps = {
  /**
   * @props {string} id - id of the menu item, used to create testid
   */
  id: string;

  /**
   * @props {string} label - label of the menu item
   */
  label: string;

  /**
   * @props {boolean} disabled - disable the menu item
   * @default false
   */
  disabled?: boolean;

  /**
   * @props {function} onClick - function to be called when the menu item is clicked
   */
  onClick?: () => void;

  /**
   * @props {boolean} blankIcon - blank icon (use to create space between menu items)
   */
  blankIcon?: boolean;

  /**
   * @props {string} icon - icon of the menu item
   */
  icon?: IconType | React.ReactNode;

  /**
   * @props {string} iconDisabled - icon of the menu item when disabled
   */
  iconDisabled?: IconType;

  /**
   * @props {boolean} divider - add a divider before the menu item
   */
  divider?: boolean;

  // /**
  //  * @props {function} handleClose - function to be called when the menu item is clicked
  //  */
  handleClose?: () => void;
};

export const ActionMenuItem = (props: ActionMenuItemProps) => {
  const {
    id,
    label,
    disabled = false,
    onClick,
    handleClose,
    blankIcon = false,
    icon = undefined,
    iconDisabled = undefined,
    divider = false,
  } = props;

  return (
    <>
      {divider && <div style={{ width: '100%', height: '1px', backgroundColor: '#d3d4d7' }} />}
      <MenuItem
        value={`${label}`}
        onClick={() => {
          if (onClick) {
            if (handleClose) handleClose();
            onClick();
          }
        }}
        disabled={disabled}
        data-testid={`actionMenuItem-${id}`}
      >
        <>
          <ActionMenuItemIcon
            id={`${id}-icon`}
            disabled={disabled}
            icon={icon}
            iconDisabled={iconDisabled}
          />
          <ListItemText
            data-testid={`${id}-label`}
            primaryTypographyProps={{ color: '#333' }}
            sx={{ marginLeft: blankIcon ? '40px' : '0' }}
          >{`${label}`}</ListItemText>
        </>
      </MenuItem>
    </>
  );
};
